/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-swiper.get-names.ts 
*/
:host {
  display: block;
}

.ace-swiper {
  box-sizing: border-box;
}
.ace-swiper__top {
  margin-bottom: var(--ace-primitive-spacing-normal);
}
.ace-swiper__top__controls {
  display: flex;
  gap: var(--ace-primitive-spacing-x-tight);
  justify-content: space-between;
}
.ace-swiper__top__actions {
  display: flex;
  gap: var(--ace-primitive-spacing-tight);
  justify-content: space-between;
}
.ace-swiper--hidden {
  display: none;
}
.ace-swiper__carousel {
  /* Fill space */
}
.ace-swiper__carousel__container {
  display: flex;
  gap: var(--ace-swiper-gap--mobile, var(--ace-primitive-spacing-normal));
  margin-right: var(--ace-swiper-gap--mobile, var(--ace-primitive-spacing-normal));
  /* Allow cards to be of dynamic width */
}
@media only screen and (min-width: 595px) {
  .ace-swiper__carousel__container {
    gap: var(--ace-swiper-gap--tablet, var(--ace-primitive-spacing-normal));
    margin-right: var(--ace-swiper-gap--mobile, var(--ace-primitive-spacing-normal));
  }
}
@media only screen and (min-width: 1025px) {
  .ace-swiper__carousel__container {
    gap: var(--ace-swiper-gap--desktop, var(--ace-primitive-spacing-normal));
    margin-right: var(--ace-swiper-gap--mobile, var(--ace-primitive-spacing-normal));
  }
}
.ace-swiper__carousel__container > * {
  cursor: grabbing;
  flex: 0 0 auto;
  height: auto;
}
.ace-swiper__carousel__container--autoplay > *:last-child {
  margin-right: var(--ace-swiper-gap--mobile, var(--ace-primitive-spacing-normal));
}
@media only screen and (min-width: 595px) {
  .ace-swiper__carousel__container--autoplay > *:last-child {
    margin-right: var(--ace-swiper-gap--mobile, var(--ace-primitive-spacing-normal));
  }
}
@media only screen and (min-width: 1025px) {
  .ace-swiper__carousel__container--autoplay > *:last-child {
    margin-right: var(--ace-swiper-gap--mobile, var(--ace-primitive-spacing-normal));
  }
}
.ace-swiper__carousel__loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 var(--ace-swiper-gap--mobile, var(--ace-primitive-spacing-normal));
  flex: 1;
}
@media only screen and (min-width: 595px) {
  .ace-swiper__carousel__loader {
    padding: 0 var(--ace-swiper-gap--tablet, var(--ace-primitive-spacing-normal));
  }
}
@media only screen and (min-width: 1025px) {
  .ace-swiper__carousel__loader {
    padding: 0 var(--ace-swiper-gap--desktop, var(--ace-primitive-spacing-normal));
  }
}
@media only screen and (min-width: 1025px) {
  .ace-swiper__carousel--fill .ace-swiper__carousel__container > * {
    max-width: unset;
  }
}
@media only screen and (min-width: calc(1600px + 4rem)) {
  .ace-swiper__carousel--fill .ace-swiper__carousel__viewport {
    padding: 0 calc((100% - 1600px) / 2);
  }
}
@media only screen and (min-width: 594px) {
  .ace-swiper__carousel--fill-1-of-2 .ace-swiper__carousel__container > * {
    width: unset;
  }
}
@media only screen and (min-width: 1025px) {
  .ace-swiper__carousel--fill-1-of-2 .ace-swiper__carousel__container > * {
    width: calc((100% - var(--ace-swiper-gap--desktop, var(--ace-primitive-spacing-normal))) / 2);
  }
}
@media only screen and (min-width: 595px) {
  .ace-swiper__carousel--fill-1-of-3 .ace-swiper__carousel__container > * {
    width: unset;
  }
}
@media only screen and (min-width: 1025px) {
  .ace-swiper__carousel--fill-1-of-3 .ace-swiper__carousel__container > * {
    width: calc((100% - 2 * var(--ace-swiper-gap--desktop, var(--ace-primitive-spacing-normal))) / 3);
  }
}
@media only screen and (min-width: 595px) {
  .ace-swiper__carousel--fill-1-of-4 .ace-swiper__carousel__container > * {
    width: unset;
  }
}
@media only screen and (min-width: 1025px) {
  .ace-swiper__carousel--fill-1-of-4 .ace-swiper__carousel__container > * {
    width: calc((100% - 3 * var(--ace-swiper-gap--desktop, var(--ace-primitive-spacing-normal))) / 4);
  }
}